import { db as rtdb } from '../utils/firebase'; // Realtime DB for presence
import { getFirestore, collection, getDocs, query, where, updateDoc } from 'firebase/firestore';

const firestore = getFirestore();

// Check if an email exists in Firestore users collection (for login)
export const isEmailAccepted = async (email) => {
  try {
    const q = query(collection(firestore, 'users'), where('email', '==', email.toLowerCase()));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking if email is accepted (Firestore):', error);
    return false;
  }
};

// Get user data from Firestore users collection
export const getAcceptedUser = async (email) => {
  try {
    const q = query(collection(firestore, 'users'), where('email', '==', email.toLowerCase()));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
      return querySnapshot.docs[0].data();
    }
    return null;
  } catch (error) {
    console.error('Error getting accepted user (Firestore):', error);
    return null;
  }
};

// Get all users from Firestore users collection (for header avatars)
export const getFirebaseUsers = async () => {
  try {
    const usersCol = collection(firestore, 'users');
    const usersSnapshot = await getDocs(usersCol);
    return usersSnapshot.docs.map(doc => doc.data());
  } catch (error) {
    console.error('Error fetching Firestore users:', error);
    return [];
  }
};

// Update user's lastSeen timestamp
export const updateUserLastSeen = async (userEmail) => {
  if (!userEmail) return;

  try {
    const q = query(collection(firestore, 'users'), where('email', '==', userEmail.toLowerCase()));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
      const userDocRef = querySnapshot.docs[0].ref;
      await updateDoc(userDocRef, {
        lastSeen: new Date().toISOString(),
      });
    }
  } catch (error) {
    console.error('Error updating lastSeen:', error);
  }
};
